export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: any }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  jsonb: any;
  smallint: any;
  timestamptz: any;
  uuid: any;
};

/** expression to compare columns of type String. All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  _nlike?: Maybe<Scalars['String']>;
  _nsimilar?: Maybe<Scalars['String']>;
  _similar?: Maybe<Scalars['String']>;
};

/**
 * Musical mode enum
 * 
 * 
 * columns and relationships of "elm.enum_music_mode"
 */
export type Elm_Enum_Music_Mode = {
  __typename?: 'elm_enum_music_mode';
  description: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_Aggregate = {
  __typename?: 'elm_enum_music_mode_aggregate';
  aggregate?: Maybe<Elm_Enum_Music_Mode_Aggregate_Fields>;
  nodes: Array<Elm_Enum_Music_Mode>;
};

/** aggregate fields of "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_Aggregate_Fields = {
  __typename?: 'elm_enum_music_mode_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Elm_Enum_Music_Mode_Max_Fields>;
  min?: Maybe<Elm_Enum_Music_Mode_Min_Fields>;
};


/** aggregate fields of "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Elm_Enum_Music_Mode_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Elm_Enum_Music_Mode_Max_Order_By>;
  min?: Maybe<Elm_Enum_Music_Mode_Min_Order_By>;
};

/** input type for inserting array relation for remote table "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_Arr_Rel_Insert_Input = {
  data: Array<Elm_Enum_Music_Mode_Insert_Input>;
  on_conflict?: Maybe<Elm_Enum_Music_Mode_On_Conflict>;
};

/** Boolean expression to filter rows from the table "elm.enum_music_mode". All fields are combined with a logical 'AND'. */
export type Elm_Enum_Music_Mode_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Elm_Enum_Music_Mode_Bool_Exp>>>;
  _not?: Maybe<Elm_Enum_Music_Mode_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Elm_Enum_Music_Mode_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "elm.enum_music_mode" */
export enum Elm_Enum_Music_Mode_Constraint {
  /** unique or primary key constraint */
  EnumMusicModePkey = 'enum_music_mode_pkey'
}

export enum Elm_Enum_Music_Mode_Enum {
  /** Harmonic Minor */
  HarmonicMinor = 'harmonic_minor',
  /** Major */
  Major = 'major',
  /** Melodic Minor */
  MelodicMinor = 'melodic_minor',
  /** Natural Minor */
  NaturalMinor = 'natural_minor'
}

/** expression to compare columns of type elm_enum_music_mode_enum. All fields are combined with logical 'AND'. */
export type Elm_Enum_Music_Mode_Enum_Comparison_Exp = {
  _eq?: Maybe<Elm_Enum_Music_Mode_Enum>;
  _in?: Maybe<Array<Elm_Enum_Music_Mode_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Elm_Enum_Music_Mode_Enum>;
  _nin?: Maybe<Array<Elm_Enum_Music_Mode_Enum>>;
};

/** input type for inserting data into table "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Elm_Enum_Music_Mode_Max_Fields = {
  __typename?: 'elm_enum_music_mode_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Elm_Enum_Music_Mode_Min_Fields = {
  __typename?: 'elm_enum_music_mode_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_Mutation_Response = {
  __typename?: 'elm_enum_music_mode_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Elm_Enum_Music_Mode>;
};

/** input type for inserting object relation for remote table "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_Obj_Rel_Insert_Input = {
  data: Elm_Enum_Music_Mode_Insert_Input;
  on_conflict?: Maybe<Elm_Enum_Music_Mode_On_Conflict>;
};

/** on conflict condition type for table "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_On_Conflict = {
  constraint: Elm_Enum_Music_Mode_Constraint;
  update_columns: Array<Elm_Enum_Music_Mode_Update_Column>;
  where?: Maybe<Elm_Enum_Music_Mode_Bool_Exp>;
};

/** ordering options when selecting data from "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "elm.enum_music_mode" */
export enum Elm_Enum_Music_Mode_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "elm.enum_music_mode" */
export type Elm_Enum_Music_Mode_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "elm.enum_music_mode" */
export enum Elm_Enum_Music_Mode_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/**
 * Pitch class enum
 * 
 * 
 * columns and relationships of "elm.enum_pitch_class"
 */
export type Elm_Enum_Pitch_Class = {
  __typename?: 'elm_enum_pitch_class';
  description: Scalars['String'];
  /** An object relationship */
  order_rel?: Maybe<Elm_Pitch_Class_Order_By>;
  value: Scalars['String'];
};

/** aggregated selection of "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_Aggregate = {
  __typename?: 'elm_enum_pitch_class_aggregate';
  aggregate?: Maybe<Elm_Enum_Pitch_Class_Aggregate_Fields>;
  nodes: Array<Elm_Enum_Pitch_Class>;
};

/** aggregate fields of "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_Aggregate_Fields = {
  __typename?: 'elm_enum_pitch_class_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Elm_Enum_Pitch_Class_Max_Fields>;
  min?: Maybe<Elm_Enum_Pitch_Class_Min_Fields>;
};


/** aggregate fields of "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Elm_Enum_Pitch_Class_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Elm_Enum_Pitch_Class_Max_Order_By>;
  min?: Maybe<Elm_Enum_Pitch_Class_Min_Order_By>;
};

/** input type for inserting array relation for remote table "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_Arr_Rel_Insert_Input = {
  data: Array<Elm_Enum_Pitch_Class_Insert_Input>;
  on_conflict?: Maybe<Elm_Enum_Pitch_Class_On_Conflict>;
};

/** Boolean expression to filter rows from the table "elm.enum_pitch_class". All fields are combined with a logical 'AND'. */
export type Elm_Enum_Pitch_Class_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Elm_Enum_Pitch_Class_Bool_Exp>>>;
  _not?: Maybe<Elm_Enum_Pitch_Class_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Elm_Enum_Pitch_Class_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  order_rel?: Maybe<Elm_Pitch_Class_Order_By_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "elm.enum_pitch_class" */
export enum Elm_Enum_Pitch_Class_Constraint {
  /** unique or primary key constraint */
  EnumPitchClassPkey = 'enum_pitch_class_pkey'
}

export enum Elm_Enum_Pitch_Class_Enum {
  /** A */
  A = 'a',
  /** A#/Bb */
  Asharp = 'asharp',
  /** B */
  B = 'b',
  /** C */
  C = 'c',
  /** C#/Db */
  Csharp = 'csharp',
  /** D */
  D = 'd',
  /** D#/Eb */
  Dsharp = 'dsharp',
  /** E */
  E = 'e',
  /** F */
  F = 'f',
  /** F#/Gb */
  Fsharp = 'fsharp',
  /** G */
  G = 'g',
  /** G#/Ab */
  Gsharp = 'gsharp'
}

/** expression to compare columns of type elm_enum_pitch_class_enum. All fields are combined with logical 'AND'. */
export type Elm_Enum_Pitch_Class_Enum_Comparison_Exp = {
  _eq?: Maybe<Elm_Enum_Pitch_Class_Enum>;
  _in?: Maybe<Array<Elm_Enum_Pitch_Class_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Elm_Enum_Pitch_Class_Enum>;
  _nin?: Maybe<Array<Elm_Enum_Pitch_Class_Enum>>;
};

/** input type for inserting data into table "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  order_rel?: Maybe<Elm_Pitch_Class_Order_By_Obj_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Elm_Enum_Pitch_Class_Max_Fields = {
  __typename?: 'elm_enum_pitch_class_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Elm_Enum_Pitch_Class_Min_Fields = {
  __typename?: 'elm_enum_pitch_class_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_Mutation_Response = {
  __typename?: 'elm_enum_pitch_class_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Elm_Enum_Pitch_Class>;
};

/** input type for inserting object relation for remote table "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_Obj_Rel_Insert_Input = {
  data: Elm_Enum_Pitch_Class_Insert_Input;
  on_conflict?: Maybe<Elm_Enum_Pitch_Class_On_Conflict>;
};

/** on conflict condition type for table "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_On_Conflict = {
  constraint: Elm_Enum_Pitch_Class_Constraint;
  update_columns: Array<Elm_Enum_Pitch_Class_Update_Column>;
  where?: Maybe<Elm_Enum_Pitch_Class_Bool_Exp>;
};

/** ordering options when selecting data from "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_Order_By = {
  description?: Maybe<Order_By>;
  order_rel?: Maybe<Elm_Pitch_Class_Order_By_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "elm.enum_pitch_class" */
export enum Elm_Enum_Pitch_Class_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "elm.enum_pitch_class" */
export type Elm_Enum_Pitch_Class_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "elm.enum_pitch_class" */
export enum Elm_Enum_Pitch_Class_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/**
 * Scale range enum
 * 
 * 
 * columns and relationships of "elm.enum_scale_range"
 */
export type Elm_Enum_Scale_Range = {
  __typename?: 'elm_enum_scale_range';
  description: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_Aggregate = {
  __typename?: 'elm_enum_scale_range_aggregate';
  aggregate?: Maybe<Elm_Enum_Scale_Range_Aggregate_Fields>;
  nodes: Array<Elm_Enum_Scale_Range>;
};

/** aggregate fields of "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_Aggregate_Fields = {
  __typename?: 'elm_enum_scale_range_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Elm_Enum_Scale_Range_Max_Fields>;
  min?: Maybe<Elm_Enum_Scale_Range_Min_Fields>;
};


/** aggregate fields of "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Elm_Enum_Scale_Range_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Elm_Enum_Scale_Range_Max_Order_By>;
  min?: Maybe<Elm_Enum_Scale_Range_Min_Order_By>;
};

/** input type for inserting array relation for remote table "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_Arr_Rel_Insert_Input = {
  data: Array<Elm_Enum_Scale_Range_Insert_Input>;
  on_conflict?: Maybe<Elm_Enum_Scale_Range_On_Conflict>;
};

/** Boolean expression to filter rows from the table "elm.enum_scale_range". All fields are combined with a logical 'AND'. */
export type Elm_Enum_Scale_Range_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Elm_Enum_Scale_Range_Bool_Exp>>>;
  _not?: Maybe<Elm_Enum_Scale_Range_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Elm_Enum_Scale_Range_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "elm.enum_scale_range" */
export enum Elm_Enum_Scale_Range_Constraint {
  /** unique or primary key constraint */
  EnumScaleRangePkey = 'enum_scale_range_pkey'
}

export enum Elm_Enum_Scale_Range_Enum {
  /** Pentatonic */
  Pentatonic = 'pentatonic',
  /** Single octave */
  SingleOctave = 'single_octave',
  /** Two octaves */
  TwoOctaves = 'two_octaves'
}

/** expression to compare columns of type elm_enum_scale_range_enum. All fields are combined with logical 'AND'. */
export type Elm_Enum_Scale_Range_Enum_Comparison_Exp = {
  _eq?: Maybe<Elm_Enum_Scale_Range_Enum>;
  _in?: Maybe<Array<Elm_Enum_Scale_Range_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Elm_Enum_Scale_Range_Enum>;
  _nin?: Maybe<Array<Elm_Enum_Scale_Range_Enum>>;
};

/** input type for inserting data into table "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Elm_Enum_Scale_Range_Max_Fields = {
  __typename?: 'elm_enum_scale_range_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Elm_Enum_Scale_Range_Min_Fields = {
  __typename?: 'elm_enum_scale_range_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_Mutation_Response = {
  __typename?: 'elm_enum_scale_range_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Elm_Enum_Scale_Range>;
};

/** input type for inserting object relation for remote table "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_Obj_Rel_Insert_Input = {
  data: Elm_Enum_Scale_Range_Insert_Input;
  on_conflict?: Maybe<Elm_Enum_Scale_Range_On_Conflict>;
};

/** on conflict condition type for table "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_On_Conflict = {
  constraint: Elm_Enum_Scale_Range_Constraint;
  update_columns: Array<Elm_Enum_Scale_Range_Update_Column>;
  where?: Maybe<Elm_Enum_Scale_Range_Bool_Exp>;
};

/** ordering options when selecting data from "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "elm.enum_scale_range" */
export enum Elm_Enum_Scale_Range_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "elm.enum_scale_range" */
export type Elm_Enum_Scale_Range_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "elm.enum_scale_range" */
export enum Elm_Enum_Scale_Range_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/**
 * Maintains the natural order of pitch classes
 * 
 * 
 * columns and relationships of "elm.pitch_class_order_by"
 */
export type Elm_Pitch_Class_Order_By = {
  __typename?: 'elm_pitch_class_order_by';
  order: Scalars['smallint'];
  pitch_class: Elm_Enum_Pitch_Class_Enum;
  /** An object relationship */
  pitch_class_rel: Elm_Enum_Pitch_Class;
};

/** aggregated selection of "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Aggregate = {
  __typename?: 'elm_pitch_class_order_by_aggregate';
  aggregate?: Maybe<Elm_Pitch_Class_Order_By_Aggregate_Fields>;
  nodes: Array<Elm_Pitch_Class_Order_By>;
};

/** aggregate fields of "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Aggregate_Fields = {
  __typename?: 'elm_pitch_class_order_by_aggregate_fields';
  avg?: Maybe<Elm_Pitch_Class_Order_By_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Elm_Pitch_Class_Order_By_Max_Fields>;
  min?: Maybe<Elm_Pitch_Class_Order_By_Min_Fields>;
  stddev?: Maybe<Elm_Pitch_Class_Order_By_Stddev_Fields>;
  stddev_pop?: Maybe<Elm_Pitch_Class_Order_By_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Elm_Pitch_Class_Order_By_Stddev_Samp_Fields>;
  sum?: Maybe<Elm_Pitch_Class_Order_By_Sum_Fields>;
  var_pop?: Maybe<Elm_Pitch_Class_Order_By_Var_Pop_Fields>;
  var_samp?: Maybe<Elm_Pitch_Class_Order_By_Var_Samp_Fields>;
  variance?: Maybe<Elm_Pitch_Class_Order_By_Variance_Fields>;
};


/** aggregate fields of "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Elm_Pitch_Class_Order_By_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Aggregate_Order_By = {
  avg?: Maybe<Elm_Pitch_Class_Order_By_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Elm_Pitch_Class_Order_By_Max_Order_By>;
  min?: Maybe<Elm_Pitch_Class_Order_By_Min_Order_By>;
  stddev?: Maybe<Elm_Pitch_Class_Order_By_Stddev_Order_By>;
  stddev_pop?: Maybe<Elm_Pitch_Class_Order_By_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Elm_Pitch_Class_Order_By_Stddev_Samp_Order_By>;
  sum?: Maybe<Elm_Pitch_Class_Order_By_Sum_Order_By>;
  var_pop?: Maybe<Elm_Pitch_Class_Order_By_Var_Pop_Order_By>;
  var_samp?: Maybe<Elm_Pitch_Class_Order_By_Var_Samp_Order_By>;
  variance?: Maybe<Elm_Pitch_Class_Order_By_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Arr_Rel_Insert_Input = {
  data: Array<Elm_Pitch_Class_Order_By_Insert_Input>;
  on_conflict?: Maybe<Elm_Pitch_Class_Order_By_On_Conflict>;
};

/** aggregate avg on columns */
export type Elm_Pitch_Class_Order_By_Avg_Fields = {
  __typename?: 'elm_pitch_class_order_by_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Avg_Order_By = {
  order?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "elm.pitch_class_order_by". All fields are combined with a logical 'AND'. */
export type Elm_Pitch_Class_Order_By_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Elm_Pitch_Class_Order_By_Bool_Exp>>>;
  _not?: Maybe<Elm_Pitch_Class_Order_By_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Elm_Pitch_Class_Order_By_Bool_Exp>>>;
  order?: Maybe<Smallint_Comparison_Exp>;
  pitch_class?: Maybe<Elm_Enum_Pitch_Class_Enum_Comparison_Exp>;
  pitch_class_rel?: Maybe<Elm_Enum_Pitch_Class_Bool_Exp>;
};

/** unique or primary key constraints on table "elm.pitch_class_order_by" */
export enum Elm_Pitch_Class_Order_By_Constraint {
  /** unique or primary key constraint */
  PitchClassOrderByOrderKey = 'pitch_class_order_by_order_key',
  /** unique or primary key constraint */
  PitchClassOrderByPkey = 'pitch_class_order_by_pkey'
}

/** input type for incrementing integer column in table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Inc_Input = {
  order?: Maybe<Scalars['smallint']>;
};

/** input type for inserting data into table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Insert_Input = {
  order?: Maybe<Scalars['smallint']>;
  pitch_class?: Maybe<Elm_Enum_Pitch_Class_Enum>;
  pitch_class_rel?: Maybe<Elm_Enum_Pitch_Class_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Elm_Pitch_Class_Order_By_Max_Fields = {
  __typename?: 'elm_pitch_class_order_by_max_fields';
  order?: Maybe<Scalars['smallint']>;
};

/** order by max() on columns of table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Max_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Elm_Pitch_Class_Order_By_Min_Fields = {
  __typename?: 'elm_pitch_class_order_by_min_fields';
  order?: Maybe<Scalars['smallint']>;
};

/** order by min() on columns of table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Min_Order_By = {
  order?: Maybe<Order_By>;
};

/** response of any mutation on the table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Mutation_Response = {
  __typename?: 'elm_pitch_class_order_by_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Elm_Pitch_Class_Order_By>;
};

/** input type for inserting object relation for remote table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Obj_Rel_Insert_Input = {
  data: Elm_Pitch_Class_Order_By_Insert_Input;
  on_conflict?: Maybe<Elm_Pitch_Class_Order_By_On_Conflict>;
};

/** on conflict condition type for table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_On_Conflict = {
  constraint: Elm_Pitch_Class_Order_By_Constraint;
  update_columns: Array<Elm_Pitch_Class_Order_By_Update_Column>;
  where?: Maybe<Elm_Pitch_Class_Order_By_Bool_Exp>;
};

/** ordering options when selecting data from "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Order_By = {
  order?: Maybe<Order_By>;
  pitch_class?: Maybe<Order_By>;
  pitch_class_rel?: Maybe<Elm_Enum_Pitch_Class_Order_By>;
};

/** primary key columns input for table: "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Pk_Columns_Input = {
  pitch_class: Elm_Enum_Pitch_Class_Enum;
};

/** select columns of table "elm.pitch_class_order_by" */
export enum Elm_Pitch_Class_Order_By_Select_Column {
  /** column name */
  Order = 'order',
  /** column name */
  PitchClass = 'pitch_class'
}

/** input type for updating data in table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Set_Input = {
  order?: Maybe<Scalars['smallint']>;
  pitch_class?: Maybe<Elm_Enum_Pitch_Class_Enum>;
};

/** aggregate stddev on columns */
export type Elm_Pitch_Class_Order_By_Stddev_Fields = {
  __typename?: 'elm_pitch_class_order_by_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Stddev_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Elm_Pitch_Class_Order_By_Stddev_Pop_Fields = {
  __typename?: 'elm_pitch_class_order_by_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Stddev_Pop_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Elm_Pitch_Class_Order_By_Stddev_Samp_Fields = {
  __typename?: 'elm_pitch_class_order_by_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Stddev_Samp_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Elm_Pitch_Class_Order_By_Sum_Fields = {
  __typename?: 'elm_pitch_class_order_by_sum_fields';
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Sum_Order_By = {
  order?: Maybe<Order_By>;
};

/** update columns of table "elm.pitch_class_order_by" */
export enum Elm_Pitch_Class_Order_By_Update_Column {
  /** column name */
  Order = 'order',
  /** column name */
  PitchClass = 'pitch_class'
}

/** aggregate var_pop on columns */
export type Elm_Pitch_Class_Order_By_Var_Pop_Fields = {
  __typename?: 'elm_pitch_class_order_by_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Var_Pop_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Elm_Pitch_Class_Order_By_Var_Samp_Fields = {
  __typename?: 'elm_pitch_class_order_by_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Var_Samp_Order_By = {
  order?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Elm_Pitch_Class_Order_By_Variance_Fields = {
  __typename?: 'elm_pitch_class_order_by_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "elm.pitch_class_order_by" */
export type Elm_Pitch_Class_Order_By_Variance_Order_By = {
  order?: Maybe<Order_By>;
};

/**
 * Configuration for scale exercises
 * 
 * 
 * columns and relationships of "elm.scale_exercise"
 */
export type Elm_Scale_Exercise = {
  __typename?: 'elm_scale_exercise';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  mode: Elm_Enum_Music_Mode_Enum;
  /** An object relationship */
  mode_rel: Elm_Enum_Music_Mode;
  pitch_class: Elm_Enum_Pitch_Class_Enum;
  /** An object relationship */
  pitch_class_rel: Elm_Enum_Pitch_Class;
  range: Elm_Enum_Scale_Range_Enum;
  /** An object relationship */
  range_rel: Elm_Enum_Scale_Range;
  updated_at: Scalars['timestamptz'];
};


/**
 * Configuration for scale exercises
 * 
 * 
 * columns and relationships of "elm.scale_exercise"
 */
export type Elm_Scale_ExerciseConfigArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "elm.scale_exercise" */
export type Elm_Scale_Exercise_Aggregate = {
  __typename?: 'elm_scale_exercise_aggregate';
  aggregate?: Maybe<Elm_Scale_Exercise_Aggregate_Fields>;
  nodes: Array<Elm_Scale_Exercise>;
};

/** aggregate fields of "elm.scale_exercise" */
export type Elm_Scale_Exercise_Aggregate_Fields = {
  __typename?: 'elm_scale_exercise_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Elm_Scale_Exercise_Max_Fields>;
  min?: Maybe<Elm_Scale_Exercise_Min_Fields>;
};


/** aggregate fields of "elm.scale_exercise" */
export type Elm_Scale_Exercise_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Elm_Scale_Exercise_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "elm.scale_exercise" */
export type Elm_Scale_Exercise_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Elm_Scale_Exercise_Max_Order_By>;
  min?: Maybe<Elm_Scale_Exercise_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Elm_Scale_Exercise_Append_Input = {
  config?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "elm.scale_exercise" */
export type Elm_Scale_Exercise_Arr_Rel_Insert_Input = {
  data: Array<Elm_Scale_Exercise_Insert_Input>;
  on_conflict?: Maybe<Elm_Scale_Exercise_On_Conflict>;
};

/** Boolean expression to filter rows from the table "elm.scale_exercise". All fields are combined with a logical 'AND'. */
export type Elm_Scale_Exercise_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Elm_Scale_Exercise_Bool_Exp>>>;
  _not?: Maybe<Elm_Scale_Exercise_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Elm_Scale_Exercise_Bool_Exp>>>;
  config?: Maybe<Jsonb_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  mode?: Maybe<Elm_Enum_Music_Mode_Enum_Comparison_Exp>;
  mode_rel?: Maybe<Elm_Enum_Music_Mode_Bool_Exp>;
  pitch_class?: Maybe<Elm_Enum_Pitch_Class_Enum_Comparison_Exp>;
  pitch_class_rel?: Maybe<Elm_Enum_Pitch_Class_Bool_Exp>;
  range?: Maybe<Elm_Enum_Scale_Range_Enum_Comparison_Exp>;
  range_rel?: Maybe<Elm_Enum_Scale_Range_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "elm.scale_exercise" */
export enum Elm_Scale_Exercise_Constraint {
  /** unique or primary key constraint */
  ScaleExercisePkey = 'scale_exercise_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Elm_Scale_Exercise_Delete_At_Path_Input = {
  config?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Elm_Scale_Exercise_Delete_Elem_Input = {
  config?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Elm_Scale_Exercise_Delete_Key_Input = {
  config?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "elm.scale_exercise" */
export type Elm_Scale_Exercise_Insert_Input = {
  config?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mode?: Maybe<Elm_Enum_Music_Mode_Enum>;
  mode_rel?: Maybe<Elm_Enum_Music_Mode_Obj_Rel_Insert_Input>;
  pitch_class?: Maybe<Elm_Enum_Pitch_Class_Enum>;
  pitch_class_rel?: Maybe<Elm_Enum_Pitch_Class_Obj_Rel_Insert_Input>;
  range?: Maybe<Elm_Enum_Scale_Range_Enum>;
  range_rel?: Maybe<Elm_Enum_Scale_Range_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Elm_Scale_Exercise_Max_Fields = {
  __typename?: 'elm_scale_exercise_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "elm.scale_exercise" */
export type Elm_Scale_Exercise_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Elm_Scale_Exercise_Min_Fields = {
  __typename?: 'elm_scale_exercise_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "elm.scale_exercise" */
export type Elm_Scale_Exercise_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "elm.scale_exercise" */
export type Elm_Scale_Exercise_Mutation_Response = {
  __typename?: 'elm_scale_exercise_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Elm_Scale_Exercise>;
};

/** input type for inserting object relation for remote table "elm.scale_exercise" */
export type Elm_Scale_Exercise_Obj_Rel_Insert_Input = {
  data: Elm_Scale_Exercise_Insert_Input;
  on_conflict?: Maybe<Elm_Scale_Exercise_On_Conflict>;
};

/** on conflict condition type for table "elm.scale_exercise" */
export type Elm_Scale_Exercise_On_Conflict = {
  constraint: Elm_Scale_Exercise_Constraint;
  update_columns: Array<Elm_Scale_Exercise_Update_Column>;
  where?: Maybe<Elm_Scale_Exercise_Bool_Exp>;
};

/** ordering options when selecting data from "elm.scale_exercise" */
export type Elm_Scale_Exercise_Order_By = {
  config?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mode?: Maybe<Order_By>;
  mode_rel?: Maybe<Elm_Enum_Music_Mode_Order_By>;
  pitch_class?: Maybe<Order_By>;
  pitch_class_rel?: Maybe<Elm_Enum_Pitch_Class_Order_By>;
  range?: Maybe<Order_By>;
  range_rel?: Maybe<Elm_Enum_Scale_Range_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: "elm.scale_exercise" */
export type Elm_Scale_Exercise_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Elm_Scale_Exercise_Prepend_Input = {
  config?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "elm.scale_exercise" */
export enum Elm_Scale_Exercise_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Mode = 'mode',
  /** column name */
  PitchClass = 'pitch_class',
  /** column name */
  Range = 'range',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "elm.scale_exercise" */
export type Elm_Scale_Exercise_Set_Input = {
  config?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mode?: Maybe<Elm_Enum_Music_Mode_Enum>;
  pitch_class?: Maybe<Elm_Enum_Pitch_Class_Enum>;
  range?: Maybe<Elm_Enum_Scale_Range_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "elm.scale_exercise" */
export enum Elm_Scale_Exercise_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Mode = 'mode',
  /** column name */
  PitchClass = 'pitch_class',
  /** column name */
  Range = 'range',
  /** column name */
  UpdatedAt = 'updated_at'
}


/** expression to compare columns of type jsonb. All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "elm.enum_music_mode" */
  delete_elm_enum_music_mode?: Maybe<Elm_Enum_Music_Mode_Mutation_Response>;
  /** delete single row from the table: "elm.enum_music_mode" */
  delete_elm_enum_music_mode_by_pk?: Maybe<Elm_Enum_Music_Mode>;
  /** delete data from the table: "elm.enum_pitch_class" */
  delete_elm_enum_pitch_class?: Maybe<Elm_Enum_Pitch_Class_Mutation_Response>;
  /** delete single row from the table: "elm.enum_pitch_class" */
  delete_elm_enum_pitch_class_by_pk?: Maybe<Elm_Enum_Pitch_Class>;
  /** delete data from the table: "elm.enum_scale_range" */
  delete_elm_enum_scale_range?: Maybe<Elm_Enum_Scale_Range_Mutation_Response>;
  /** delete single row from the table: "elm.enum_scale_range" */
  delete_elm_enum_scale_range_by_pk?: Maybe<Elm_Enum_Scale_Range>;
  /** delete data from the table: "elm.pitch_class_order_by" */
  delete_elm_pitch_class_order_by?: Maybe<Elm_Pitch_Class_Order_By_Mutation_Response>;
  /** delete single row from the table: "elm.pitch_class_order_by" */
  delete_elm_pitch_class_order_by_by_pk?: Maybe<Elm_Pitch_Class_Order_By>;
  /** delete data from the table: "elm.scale_exercise" */
  delete_elm_scale_exercise?: Maybe<Elm_Scale_Exercise_Mutation_Response>;
  /** delete single row from the table: "elm.scale_exercise" */
  delete_elm_scale_exercise_by_pk?: Maybe<Elm_Scale_Exercise>;
  /** insert data into the table: "elm.enum_music_mode" */
  insert_elm_enum_music_mode?: Maybe<Elm_Enum_Music_Mode_Mutation_Response>;
  /** insert a single row into the table: "elm.enum_music_mode" */
  insert_elm_enum_music_mode_one?: Maybe<Elm_Enum_Music_Mode>;
  /** insert data into the table: "elm.enum_pitch_class" */
  insert_elm_enum_pitch_class?: Maybe<Elm_Enum_Pitch_Class_Mutation_Response>;
  /** insert a single row into the table: "elm.enum_pitch_class" */
  insert_elm_enum_pitch_class_one?: Maybe<Elm_Enum_Pitch_Class>;
  /** insert data into the table: "elm.enum_scale_range" */
  insert_elm_enum_scale_range?: Maybe<Elm_Enum_Scale_Range_Mutation_Response>;
  /** insert a single row into the table: "elm.enum_scale_range" */
  insert_elm_enum_scale_range_one?: Maybe<Elm_Enum_Scale_Range>;
  /** insert data into the table: "elm.pitch_class_order_by" */
  insert_elm_pitch_class_order_by?: Maybe<Elm_Pitch_Class_Order_By_Mutation_Response>;
  /** insert a single row into the table: "elm.pitch_class_order_by" */
  insert_elm_pitch_class_order_by_one?: Maybe<Elm_Pitch_Class_Order_By>;
  /** insert data into the table: "elm.scale_exercise" */
  insert_elm_scale_exercise?: Maybe<Elm_Scale_Exercise_Mutation_Response>;
  /** insert a single row into the table: "elm.scale_exercise" */
  insert_elm_scale_exercise_one?: Maybe<Elm_Scale_Exercise>;
  /** update data of the table: "elm.enum_music_mode" */
  update_elm_enum_music_mode?: Maybe<Elm_Enum_Music_Mode_Mutation_Response>;
  /** update single row of the table: "elm.enum_music_mode" */
  update_elm_enum_music_mode_by_pk?: Maybe<Elm_Enum_Music_Mode>;
  /** update data of the table: "elm.enum_pitch_class" */
  update_elm_enum_pitch_class?: Maybe<Elm_Enum_Pitch_Class_Mutation_Response>;
  /** update single row of the table: "elm.enum_pitch_class" */
  update_elm_enum_pitch_class_by_pk?: Maybe<Elm_Enum_Pitch_Class>;
  /** update data of the table: "elm.enum_scale_range" */
  update_elm_enum_scale_range?: Maybe<Elm_Enum_Scale_Range_Mutation_Response>;
  /** update single row of the table: "elm.enum_scale_range" */
  update_elm_enum_scale_range_by_pk?: Maybe<Elm_Enum_Scale_Range>;
  /** update data of the table: "elm.pitch_class_order_by" */
  update_elm_pitch_class_order_by?: Maybe<Elm_Pitch_Class_Order_By_Mutation_Response>;
  /** update single row of the table: "elm.pitch_class_order_by" */
  update_elm_pitch_class_order_by_by_pk?: Maybe<Elm_Pitch_Class_Order_By>;
  /** update data of the table: "elm.scale_exercise" */
  update_elm_scale_exercise?: Maybe<Elm_Scale_Exercise_Mutation_Response>;
  /** update single row of the table: "elm.scale_exercise" */
  update_elm_scale_exercise_by_pk?: Maybe<Elm_Scale_Exercise>;
};


/** mutation root */
export type Mutation_RootDelete_Elm_Enum_Music_ModeArgs = {
  where: Elm_Enum_Music_Mode_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Elm_Enum_Music_Mode_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Elm_Enum_Pitch_ClassArgs = {
  where: Elm_Enum_Pitch_Class_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Elm_Enum_Pitch_Class_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Elm_Enum_Scale_RangeArgs = {
  where: Elm_Enum_Scale_Range_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Elm_Enum_Scale_Range_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Elm_Pitch_Class_Order_ByArgs = {
  where: Elm_Pitch_Class_Order_By_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Elm_Pitch_Class_Order_By_By_PkArgs = {
  pitch_class: Elm_Enum_Pitch_Class_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Elm_Scale_ExerciseArgs = {
  where: Elm_Scale_Exercise_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Elm_Scale_Exercise_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsert_Elm_Enum_Music_ModeArgs = {
  objects: Array<Elm_Enum_Music_Mode_Insert_Input>;
  on_conflict?: Maybe<Elm_Enum_Music_Mode_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Elm_Enum_Music_Mode_OneArgs = {
  object: Elm_Enum_Music_Mode_Insert_Input;
  on_conflict?: Maybe<Elm_Enum_Music_Mode_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Elm_Enum_Pitch_ClassArgs = {
  objects: Array<Elm_Enum_Pitch_Class_Insert_Input>;
  on_conflict?: Maybe<Elm_Enum_Pitch_Class_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Elm_Enum_Pitch_Class_OneArgs = {
  object: Elm_Enum_Pitch_Class_Insert_Input;
  on_conflict?: Maybe<Elm_Enum_Pitch_Class_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Elm_Enum_Scale_RangeArgs = {
  objects: Array<Elm_Enum_Scale_Range_Insert_Input>;
  on_conflict?: Maybe<Elm_Enum_Scale_Range_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Elm_Enum_Scale_Range_OneArgs = {
  object: Elm_Enum_Scale_Range_Insert_Input;
  on_conflict?: Maybe<Elm_Enum_Scale_Range_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Elm_Pitch_Class_Order_ByArgs = {
  objects: Array<Elm_Pitch_Class_Order_By_Insert_Input>;
  on_conflict?: Maybe<Elm_Pitch_Class_Order_By_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Elm_Pitch_Class_Order_By_OneArgs = {
  object: Elm_Pitch_Class_Order_By_Insert_Input;
  on_conflict?: Maybe<Elm_Pitch_Class_Order_By_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Elm_Scale_ExerciseArgs = {
  objects: Array<Elm_Scale_Exercise_Insert_Input>;
  on_conflict?: Maybe<Elm_Scale_Exercise_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Elm_Scale_Exercise_OneArgs = {
  object: Elm_Scale_Exercise_Insert_Input;
  on_conflict?: Maybe<Elm_Scale_Exercise_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_Elm_Enum_Music_ModeArgs = {
  _set?: Maybe<Elm_Enum_Music_Mode_Set_Input>;
  where: Elm_Enum_Music_Mode_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Elm_Enum_Music_Mode_By_PkArgs = {
  _set?: Maybe<Elm_Enum_Music_Mode_Set_Input>;
  pk_columns: Elm_Enum_Music_Mode_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Elm_Enum_Pitch_ClassArgs = {
  _set?: Maybe<Elm_Enum_Pitch_Class_Set_Input>;
  where: Elm_Enum_Pitch_Class_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Elm_Enum_Pitch_Class_By_PkArgs = {
  _set?: Maybe<Elm_Enum_Pitch_Class_Set_Input>;
  pk_columns: Elm_Enum_Pitch_Class_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Elm_Enum_Scale_RangeArgs = {
  _set?: Maybe<Elm_Enum_Scale_Range_Set_Input>;
  where: Elm_Enum_Scale_Range_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Elm_Enum_Scale_Range_By_PkArgs = {
  _set?: Maybe<Elm_Enum_Scale_Range_Set_Input>;
  pk_columns: Elm_Enum_Scale_Range_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Elm_Pitch_Class_Order_ByArgs = {
  _inc?: Maybe<Elm_Pitch_Class_Order_By_Inc_Input>;
  _set?: Maybe<Elm_Pitch_Class_Order_By_Set_Input>;
  where: Elm_Pitch_Class_Order_By_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Elm_Pitch_Class_Order_By_By_PkArgs = {
  _inc?: Maybe<Elm_Pitch_Class_Order_By_Inc_Input>;
  _set?: Maybe<Elm_Pitch_Class_Order_By_Set_Input>;
  pk_columns: Elm_Pitch_Class_Order_By_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Elm_Scale_ExerciseArgs = {
  _append?: Maybe<Elm_Scale_Exercise_Append_Input>;
  _delete_at_path?: Maybe<Elm_Scale_Exercise_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Elm_Scale_Exercise_Delete_Elem_Input>;
  _delete_key?: Maybe<Elm_Scale_Exercise_Delete_Key_Input>;
  _prepend?: Maybe<Elm_Scale_Exercise_Prepend_Input>;
  _set?: Maybe<Elm_Scale_Exercise_Set_Input>;
  where: Elm_Scale_Exercise_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Elm_Scale_Exercise_By_PkArgs = {
  _append?: Maybe<Elm_Scale_Exercise_Append_Input>;
  _delete_at_path?: Maybe<Elm_Scale_Exercise_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Elm_Scale_Exercise_Delete_Elem_Input>;
  _delete_key?: Maybe<Elm_Scale_Exercise_Delete_Key_Input>;
  _prepend?: Maybe<Elm_Scale_Exercise_Prepend_Input>;
  _set?: Maybe<Elm_Scale_Exercise_Set_Input>;
  pk_columns: Elm_Scale_Exercise_Pk_Columns_Input;
};

/** column ordering options */
export enum Order_By {
  /** in the ascending order, nulls last */
  Asc = 'asc',
  /** in the ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in the ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in the descending order, nulls first */
  Desc = 'desc',
  /** in the descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in the descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** query root */
export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "elm.enum_music_mode" */
  elm_enum_music_mode: Array<Elm_Enum_Music_Mode>;
  /** fetch aggregated fields from the table: "elm.enum_music_mode" */
  elm_enum_music_mode_aggregate: Elm_Enum_Music_Mode_Aggregate;
  /** fetch data from the table: "elm.enum_music_mode" using primary key columns */
  elm_enum_music_mode_by_pk?: Maybe<Elm_Enum_Music_Mode>;
  /** fetch data from the table: "elm.enum_pitch_class" */
  elm_enum_pitch_class: Array<Elm_Enum_Pitch_Class>;
  /** fetch aggregated fields from the table: "elm.enum_pitch_class" */
  elm_enum_pitch_class_aggregate: Elm_Enum_Pitch_Class_Aggregate;
  /** fetch data from the table: "elm.enum_pitch_class" using primary key columns */
  elm_enum_pitch_class_by_pk?: Maybe<Elm_Enum_Pitch_Class>;
  /** fetch data from the table: "elm.enum_scale_range" */
  elm_enum_scale_range: Array<Elm_Enum_Scale_Range>;
  /** fetch aggregated fields from the table: "elm.enum_scale_range" */
  elm_enum_scale_range_aggregate: Elm_Enum_Scale_Range_Aggregate;
  /** fetch data from the table: "elm.enum_scale_range" using primary key columns */
  elm_enum_scale_range_by_pk?: Maybe<Elm_Enum_Scale_Range>;
  /** fetch data from the table: "elm.pitch_class_order_by" */
  elm_pitch_class_order_by: Array<Elm_Pitch_Class_Order_By>;
  /** fetch aggregated fields from the table: "elm.pitch_class_order_by" */
  elm_pitch_class_order_by_aggregate: Elm_Pitch_Class_Order_By_Aggregate;
  /** fetch data from the table: "elm.pitch_class_order_by" using primary key columns */
  elm_pitch_class_order_by_by_pk?: Maybe<Elm_Pitch_Class_Order_By>;
  /** fetch data from the table: "elm.scale_exercise" */
  elm_scale_exercise: Array<Elm_Scale_Exercise>;
  /** fetch aggregated fields from the table: "elm.scale_exercise" */
  elm_scale_exercise_aggregate: Elm_Scale_Exercise_Aggregate;
  /** fetch data from the table: "elm.scale_exercise" using primary key columns */
  elm_scale_exercise_by_pk?: Maybe<Elm_Scale_Exercise>;
};


/** query root */
export type Query_RootElm_Enum_Music_ModeArgs = {
  distinct_on?: Maybe<Array<Elm_Enum_Music_Mode_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Enum_Music_Mode_Order_By>>;
  where?: Maybe<Elm_Enum_Music_Mode_Bool_Exp>;
};


/** query root */
export type Query_RootElm_Enum_Music_Mode_AggregateArgs = {
  distinct_on?: Maybe<Array<Elm_Enum_Music_Mode_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Enum_Music_Mode_Order_By>>;
  where?: Maybe<Elm_Enum_Music_Mode_Bool_Exp>;
};


/** query root */
export type Query_RootElm_Enum_Music_Mode_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootElm_Enum_Pitch_ClassArgs = {
  distinct_on?: Maybe<Array<Elm_Enum_Pitch_Class_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Enum_Pitch_Class_Order_By>>;
  where?: Maybe<Elm_Enum_Pitch_Class_Bool_Exp>;
};


/** query root */
export type Query_RootElm_Enum_Pitch_Class_AggregateArgs = {
  distinct_on?: Maybe<Array<Elm_Enum_Pitch_Class_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Enum_Pitch_Class_Order_By>>;
  where?: Maybe<Elm_Enum_Pitch_Class_Bool_Exp>;
};


/** query root */
export type Query_RootElm_Enum_Pitch_Class_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootElm_Enum_Scale_RangeArgs = {
  distinct_on?: Maybe<Array<Elm_Enum_Scale_Range_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Enum_Scale_Range_Order_By>>;
  where?: Maybe<Elm_Enum_Scale_Range_Bool_Exp>;
};


/** query root */
export type Query_RootElm_Enum_Scale_Range_AggregateArgs = {
  distinct_on?: Maybe<Array<Elm_Enum_Scale_Range_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Enum_Scale_Range_Order_By>>;
  where?: Maybe<Elm_Enum_Scale_Range_Bool_Exp>;
};


/** query root */
export type Query_RootElm_Enum_Scale_Range_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootElm_Pitch_Class_Order_ByArgs = {
  distinct_on?: Maybe<Array<Elm_Pitch_Class_Order_By_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Pitch_Class_Order_By_Order_By>>;
  where?: Maybe<Elm_Pitch_Class_Order_By_Bool_Exp>;
};


/** query root */
export type Query_RootElm_Pitch_Class_Order_By_AggregateArgs = {
  distinct_on?: Maybe<Array<Elm_Pitch_Class_Order_By_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Pitch_Class_Order_By_Order_By>>;
  where?: Maybe<Elm_Pitch_Class_Order_By_Bool_Exp>;
};


/** query root */
export type Query_RootElm_Pitch_Class_Order_By_By_PkArgs = {
  pitch_class: Elm_Enum_Pitch_Class_Enum;
};


/** query root */
export type Query_RootElm_Scale_ExerciseArgs = {
  distinct_on?: Maybe<Array<Elm_Scale_Exercise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Scale_Exercise_Order_By>>;
  where?: Maybe<Elm_Scale_Exercise_Bool_Exp>;
};


/** query root */
export type Query_RootElm_Scale_Exercise_AggregateArgs = {
  distinct_on?: Maybe<Array<Elm_Scale_Exercise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Scale_Exercise_Order_By>>;
  where?: Maybe<Elm_Scale_Exercise_Bool_Exp>;
};


/** query root */
export type Query_RootElm_Scale_Exercise_By_PkArgs = {
  id: Scalars['uuid'];
};


/** expression to compare columns of type smallint. All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: Maybe<Scalars['smallint']>;
  _gt?: Maybe<Scalars['smallint']>;
  _gte?: Maybe<Scalars['smallint']>;
  _in?: Maybe<Array<Scalars['smallint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['smallint']>;
  _lte?: Maybe<Scalars['smallint']>;
  _neq?: Maybe<Scalars['smallint']>;
  _nin?: Maybe<Array<Scalars['smallint']>>;
};

/** subscription root */
export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "elm.enum_music_mode" */
  elm_enum_music_mode: Array<Elm_Enum_Music_Mode>;
  /** fetch aggregated fields from the table: "elm.enum_music_mode" */
  elm_enum_music_mode_aggregate: Elm_Enum_Music_Mode_Aggregate;
  /** fetch data from the table: "elm.enum_music_mode" using primary key columns */
  elm_enum_music_mode_by_pk?: Maybe<Elm_Enum_Music_Mode>;
  /** fetch data from the table: "elm.enum_pitch_class" */
  elm_enum_pitch_class: Array<Elm_Enum_Pitch_Class>;
  /** fetch aggregated fields from the table: "elm.enum_pitch_class" */
  elm_enum_pitch_class_aggregate: Elm_Enum_Pitch_Class_Aggregate;
  /** fetch data from the table: "elm.enum_pitch_class" using primary key columns */
  elm_enum_pitch_class_by_pk?: Maybe<Elm_Enum_Pitch_Class>;
  /** fetch data from the table: "elm.enum_scale_range" */
  elm_enum_scale_range: Array<Elm_Enum_Scale_Range>;
  /** fetch aggregated fields from the table: "elm.enum_scale_range" */
  elm_enum_scale_range_aggregate: Elm_Enum_Scale_Range_Aggregate;
  /** fetch data from the table: "elm.enum_scale_range" using primary key columns */
  elm_enum_scale_range_by_pk?: Maybe<Elm_Enum_Scale_Range>;
  /** fetch data from the table: "elm.pitch_class_order_by" */
  elm_pitch_class_order_by: Array<Elm_Pitch_Class_Order_By>;
  /** fetch aggregated fields from the table: "elm.pitch_class_order_by" */
  elm_pitch_class_order_by_aggregate: Elm_Pitch_Class_Order_By_Aggregate;
  /** fetch data from the table: "elm.pitch_class_order_by" using primary key columns */
  elm_pitch_class_order_by_by_pk?: Maybe<Elm_Pitch_Class_Order_By>;
  /** fetch data from the table: "elm.scale_exercise" */
  elm_scale_exercise: Array<Elm_Scale_Exercise>;
  /** fetch aggregated fields from the table: "elm.scale_exercise" */
  elm_scale_exercise_aggregate: Elm_Scale_Exercise_Aggregate;
  /** fetch data from the table: "elm.scale_exercise" using primary key columns */
  elm_scale_exercise_by_pk?: Maybe<Elm_Scale_Exercise>;
};


/** subscription root */
export type Subscription_RootElm_Enum_Music_ModeArgs = {
  distinct_on?: Maybe<Array<Elm_Enum_Music_Mode_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Enum_Music_Mode_Order_By>>;
  where?: Maybe<Elm_Enum_Music_Mode_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootElm_Enum_Music_Mode_AggregateArgs = {
  distinct_on?: Maybe<Array<Elm_Enum_Music_Mode_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Enum_Music_Mode_Order_By>>;
  where?: Maybe<Elm_Enum_Music_Mode_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootElm_Enum_Music_Mode_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootElm_Enum_Pitch_ClassArgs = {
  distinct_on?: Maybe<Array<Elm_Enum_Pitch_Class_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Enum_Pitch_Class_Order_By>>;
  where?: Maybe<Elm_Enum_Pitch_Class_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootElm_Enum_Pitch_Class_AggregateArgs = {
  distinct_on?: Maybe<Array<Elm_Enum_Pitch_Class_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Enum_Pitch_Class_Order_By>>;
  where?: Maybe<Elm_Enum_Pitch_Class_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootElm_Enum_Pitch_Class_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootElm_Enum_Scale_RangeArgs = {
  distinct_on?: Maybe<Array<Elm_Enum_Scale_Range_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Enum_Scale_Range_Order_By>>;
  where?: Maybe<Elm_Enum_Scale_Range_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootElm_Enum_Scale_Range_AggregateArgs = {
  distinct_on?: Maybe<Array<Elm_Enum_Scale_Range_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Enum_Scale_Range_Order_By>>;
  where?: Maybe<Elm_Enum_Scale_Range_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootElm_Enum_Scale_Range_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootElm_Pitch_Class_Order_ByArgs = {
  distinct_on?: Maybe<Array<Elm_Pitch_Class_Order_By_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Pitch_Class_Order_By_Order_By>>;
  where?: Maybe<Elm_Pitch_Class_Order_By_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootElm_Pitch_Class_Order_By_AggregateArgs = {
  distinct_on?: Maybe<Array<Elm_Pitch_Class_Order_By_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Pitch_Class_Order_By_Order_By>>;
  where?: Maybe<Elm_Pitch_Class_Order_By_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootElm_Pitch_Class_Order_By_By_PkArgs = {
  pitch_class: Elm_Enum_Pitch_Class_Enum;
};


/** subscription root */
export type Subscription_RootElm_Scale_ExerciseArgs = {
  distinct_on?: Maybe<Array<Elm_Scale_Exercise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Scale_Exercise_Order_By>>;
  where?: Maybe<Elm_Scale_Exercise_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootElm_Scale_Exercise_AggregateArgs = {
  distinct_on?: Maybe<Array<Elm_Scale_Exercise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Elm_Scale_Exercise_Order_By>>;
  where?: Maybe<Elm_Scale_Exercise_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootElm_Scale_Exercise_By_PkArgs = {
  id: Scalars['uuid'];
};


/** expression to compare columns of type timestamptz. All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};


/** expression to compare columns of type uuid. All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

